import React, { useState, useEffect, useRef } from "react";
import "../stylesheets2025/CustomCarousel.css";

const ImageSlider = ({ items, autoSlide = true, autoSlideInterval = 3000, pauseDuration = 5000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    const intervalRef = useRef(null);

    // Next & Prev
    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === items.length - 1 ? 0 : prevIndex + 1
        );
        pauseAutoSlide();
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? items.length - 1 : prevIndex - 1
        );
        pauseAutoSlide();
    };

    // Pause logic
    const pauseAutoSlide = () => {
        setIsPaused(true);
        clearInterval(intervalRef.current);
        setTimeout(() => setIsPaused(false), pauseDuration); // resume later
    };

    // Auto-slide logic
    useEffect(() => {
        if (!autoSlide || isPaused) return;

        intervalRef.current = setInterval(nextSlide, autoSlideInterval);
        return () => clearInterval(intervalRef.current);
    }, [autoSlide, autoSlideInterval, isPaused]);

    return (
        <div className="slider-container">
            <div
                className="slider-content"
                style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
                {items.map((item, index) => (
                    <div className="slide" key={index}>
                        <img src={item.image} alt={`slide-${index}`} className="carousel-img" />
                    </div>
                ))}
            </div>

            <button className="nav-button prev" onClick={prevSlide}>‹</button>
            <button className="nav-button next" onClick={nextSlide}>›</button>

            <div className="dots">
                {items.map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${index === currentIndex ? "active" : ""}`}
                        onClick={() => {
                            setCurrentIndex(index);
                            pauseAutoSlide();
                        }}
                    ></span>
                ))}
            </div>
        </div>
    );
};

export default ImageSlider;
